
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {NationalTeamsService} from './national-teams.service';
import {first, map, share} from "rxjs/operators";

@Injectable()
export class PageService {
    public userPage: any;
    public teamPage: any;
    public nationalTeamPage: any;

    private userPageObservable: Observable<any>;
    private teamPageObservable: Observable<any>;
    private nationalTeamPageObservable: Observable<any>;

    constructor(private http: HttpClient, private router: Router, private nationalTeamsService: NationalTeamsService) {}

    getTeamPage(participantId, teamId, forceReload) {
        if (teamId) {
            if (this.teamPage && !forceReload) {
                this.teamPageObservable = observableOf(this.teamPage);
            } else if (this.teamPageObservable && !forceReload) {
                // do nothing. the request is in progress
            } else {
                var o = this.http.get('/api/v1/teams/' + teamId + '/' + participantId + '/page');
                this.teamPageObservable = o.pipe(map(res => {
                    this.teamPage = res;
                    return res;
                }), first(), share());
            }
            return this.teamPageObservable;
        }
    }

    getUserPage(participantId, forceReload) {
        if (this.userPage && !forceReload) {
            this.userPageObservable = observableOf(this.userPage);
        } else if (this.userPageObservable && !forceReload) {
            // do nothing. the request is in progress
        } else {
            var o = this.http.get('/api/v1/user/participant/' + participantId + '/page');
            this.userPageObservable = o.pipe(map(res => {
                this.userPage = res;
                if(this.userPage.fullUrl) {
                    this.userPage.fullUrl = this.userPage.fullUrl.replace('http://', 'https://');
                }
                return res;
            }), first(), share());
        }
        return this.userPageObservable;
    }

    getNationalTeamPage(pageId, forceReload) {
        if (this.nationalTeamPage && !forceReload) {
            this.nationalTeamPageObservable = observableOf(this.nationalTeamPage);
        } else if (this.nationalTeamPageObservable && !forceReload) {
            // do nothing. the request is in progress
        } else {
            let o = this.http.get('/api/v1/pages/' + pageId);
            this.nationalTeamPageObservable = o.pipe(map(res => {
                this.nationalTeamPage = res;
                return res;
            }), first(), share());
        }
        return this.nationalTeamPageObservable;
    }

    updatePageOptions(pageId, model) {
        return this.http.post('/api/v1/pages/' + pageId + '/options' , model).pipe(map(res => {
            return res;
        }));
    }

    uploadImage(participantId, image) {
        return this.http.post('/api/v1/user/participant/' + participantId + '/images' , image).pipe(map(res => {
            return res;
        }));
    }

    getPageById(pageId) {
        if (!this.userPage) {
            this.router.navigate(['/home']);
        } else if (this.userPage && this.userPage.pageID === pageId) {
            return this.userPage;
        } else if (this.teamPage && this.teamPage.pageID === pageId) {
            return this.teamPage;
        } else {
            this.router.navigate(['/home']);
        }
    }

    getPageForNationalTeam(pageId) {
        if (!this.nationalTeamPage || this.nationalTeamPage.pageID !== pageId ) {
            this.router.navigate(['/national/teams/' + this.nationalTeamsService.selectedNationalTeam.teamId]);
        } else if (this.nationalTeamPage && this.nationalTeamPage.pageID === pageId) {
            return this.nationalTeamPage;
        }
    }
}
